// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3OYGH","avatarSvg":"_3cgi0","memberInitials":"_1EdKQ"};